export default function KvkkPolicy() {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center px-6 bg-gray-100 text-gray-900">
            <div className="max-w-3xl text-center bg-white p-8 rounded-lg shadow-lg">
                <h1 className="text-3xl font-bold mb-6">KVKK Policy</h1>
                <p className="text-lg leading-relaxed">
                    Arkenom Teknoloji acts as the data controller within the scope of the Personal Data Protection Law 
                    No. 6698 (KVKK). In this context, we are committed to ensuring full compliance with the relevant 
                    legal provisions in the processes of processing and protecting personal data.
                </p>
                <p className="mt-4 text-lg leading-relaxed">
                    Your personal data is processed in accordance with the KVKK. Below, you can find detailed 
                    information regarding the purposes of data processing, legal basis, and your rights as a data subject.
                </p>
                <ul className="mt-4 text-lg leading-relaxed text-left list-disc list-inside">
                    <li>Purposes of personal data processing</li>
                    <li>Legal basis</li>
                    <li>Rights of the data subject</li>
                </ul>
                <p className="mt-4 text-lg leading-relaxed">
                    As the data controller, we process your personal data strictly within the legal framework and for 
                    the specified purposes. For more information, please contact us.
                </p>
            </div>
        </div>
    );
}
